import { getConfigModules } from './utils'

const logoPath = `assets/img/logo.svg`
export const logoSvg = getConfigModules(logoPath)

const sponsoredHeadlinesPath = `assets/js/sponsoredHeadlines.js`
export const sponsoredHeadlines = getConfigModules(sponsoredHeadlinesPath)
